import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class VipDinerService {
  private apiUrl = environment.baseUrl;

  constructor(private http: HttpClient) {}

  // Get VIP Diner reservations list
  getVipDinerReservations(token: string): Observable<any> {
    return this.http.get(`${this.apiUrl}getVipDinerReservations`, {
      headers: { accessToken: `${token}` },
    });
  }

  // Get VIP Diner reservation by ID
  getVipDinerReservationById(id: number, token: string): Observable<any> {
    return this.http.get(`${this.apiUrl}getVipDinerReservation/${id}`, {
      headers: { accessToken: `${token}` },
    });
  }

  // Legacy methods for backward compatibility
  getVipDinerList(params: any, token: string): Observable<any> {
    return this.getVipDinerReservations(token);
  }

  getVipDinerById(id: number, token: string): Observable<any> {
    return this.getVipDinerReservationById(id, token);
  }

  // Create new VIP Diner reservation
  createVipDinerReservation(data: any, token: string): Observable<any> {
    return this.http.post(`${this.apiUrl}createVipDinerReservation`, data, {
      headers: { accessToken: `${token}` },
    });
  }

  // Legacy method for backward compatibility
  createVipDiner(data: any, token: string): Observable<any> {
    return this.createVipDinerReservation(data, token);
  }

  // Update VIP Diner
  updateVipDiner(id: number, data: any, token: string): Observable<any> {
    return this.http.put(`${this.apiUrl}/reservations/${id}`, data, {
      headers: { accessToken: `${token}` },
    });
  }

  // Delete VIP Diner
  deleteVipDiner(id: number, token: string): Observable<any> {
    return this.http.delete(`${this.apiUrl}/reservations/${id}`, {
      headers: { accessToken: `${token}` },
    });
  }

  // Update VIP Diner status
  updateVipDinerStatus(
    id: number,
    status: string,
    token: string
  ): Observable<any> {
    return this.http.patch(
      `${this.apiUrl}/reservations/${id}/status`,
      { status },
      {
        headers: { accessToken: `${token}` },
      }
    );
  }

  // Add users to VIP Diner reservation
  addUserToVipDiner(
    reservationId: number,
    userData: any,
    token: string
  ): Observable<any> {
    return this.http.post(
      `${this.apiUrl}addUserToVipDiner/${reservationId}`,
      userData,
      {
        headers: { accessToken: `${token}` },
      }
    );
  }

  // Manage VIP Diner user (add/remove)
  manageVipDinerUser(
    reservationId: number,
    customerId: number,
    gender: string,
    action: string,
    token: string
  ): Observable<any> {
    return this.http.post(
      `${this.apiUrl}manageVipDinerUser/${reservationId}`,
      {
        customer_id: customerId,
        gender: gender,
        action: action,
      },
      {
        headers: { accessToken: `${token}` },
      }
    );
  }

  // Update VIP Diner reservation (public/private/delete/update)
  updateVipDinerReservation(
    reservationId: number,
    updateData?: any,
    token?: string
  ): Observable<any> {
    return this.http.post(
      `${this.apiUrl}updateVipDinerReservation/${reservationId}`,
      updateData,
      {
        headers: { accessToken: `${token}` },
      }
    );
  }
}
